<div class="flex flex-col items-center flex-1 w-full min-h-0">

  <!-- Zone activité avec hover expand -->
  <div class="group w-full min-h-[56px] border-b border-lilate-border flex items-center justify-center
              relative overflow-hidden cursor-pointer"
       [matTooltip]="'exam-assistant-rail.open-help' | translate"
       matTooltipPosition="left"
       (click)="expand.emit()">
    <svg class="w-5 h-5 text-lilate-dark fill-none transition-opacity duration-[180ms]
                group-hover:opacity-0"
         viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round">
      <path d="M12 20h9M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"/>
    </svg>
    <div class="absolute inset-0 flex items-center justify-center bg-[rgba(220,245,234,0.92)]
                opacity-0 transition-opacity duration-[180ms] group-hover:opacity-100">
      <svg class="w-5 h-5 text-lilate-dark" viewBox="0 0 24 24" fill="none" stroke="currentColor"
           stroke-width="2" stroke-linecap="round">
        <polyline points="11 9 8 12 11 15"/>
      </svg>
    </div>
  </div>

  <!-- Timer compact -->
  @if (showTimer()) {
  <div class="w-full py-3.5 pb-2.5 border-b border-lilate-border flex flex-col items-center gap-0.5
              shrink-0 cursor-pointer"
       (click)="expand.emit()">
    <div class="text-[8px] font-semibold text-lilate-dark uppercase tracking-[0.06em]" translate>exam-assistant-rail.time</div>
    <div class="font-dm-serif text-[17px] text-lilate-ink leading-none tracking-tight">{{ compactTime() }}</div>
  </div>
  }

  <!-- Icônes d'action -->
  <div class="flex flex-col items-center gap-1 py-3 flex-1 w-full">
    <div class="w-10 h-10 rounded-[9px] flex items-center justify-center cursor-pointer
                transition-colors duration-150 hover:bg-lilate/[0.12]"
         [matTooltip]="'exam-action-buttons.reformulate' | translate"
         matTooltipPosition="left"
         (click)="reformulate.emit()">
      <svg class="w-[18px] h-[18px] text-lilate-dark" viewBox="0 0 24 24" fill="none" stroke="currentColor"
           stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
        <path d="M12 2a10 10 0 0 1 7.38 16.75
                 M12 22a10 10 0 0 1-7.38-16.75"/>
        <path d="M12 6v2M12 16v2M6 12H4M20 12h-2"/>
      </svg>
    </div>
    <div class="w-10 h-10 rounded-[9px] flex items-center justify-center cursor-pointer
                transition-colors duration-150 hover:bg-lilate/[0.12]"
         [matTooltip]="'exam-action-buttons.listen' | translate"
         matTooltipPosition="left"
         (click)="toggleTts.emit()">
      <svg class="w-[18px] h-[18px] text-lilate-dark" viewBox="0 0 24 24" fill="none" stroke="currentColor"
           stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
        <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/>
        <path d="M15.54 8.46a5 5 0 0 1 0 7.07"/>
      </svg>
    </div>
    <div class="w-10 h-10 rounded-[9px] flex items-center justify-center cursor-pointer
                transition-colors duration-150 hover:bg-lilate/[0.12]"
         [matTooltip]="'exam-criteria-list.title' | translate"
         matTooltipPosition="left"
         (click)="expand.emit()">
      <svg class="w-[18px] h-[18px] text-lilate-dark" viewBox="0 0 24 24" fill="none" stroke="currentColor"
           stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="9 11 12 14 22 4"/>
        <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>
      </svg>
    </div>
  </div>

  <!-- Conseil + réglages + abandon en bas -->
  <div class="flex flex-col items-center gap-1 w-full py-2 pb-3.5 border-t border-lilate-border">
    <div class="w-10 h-10 rounded-[9px] flex items-center justify-center cursor-pointer
                transition-colors duration-150 hover:bg-lilate/[0.12]"
         [matTooltip]="'exam-advice-card.title' | translate"
         matTooltipPosition="left"
         (click)="expand.emit()">
      <svg class="w-[18px] h-[18px] text-lilate-dark" viewBox="0 0 24 24" fill="none" stroke="currentColor"
           stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"/>
        <line x1="12" y1="16" x2="12" y2="12"/>
        <line x1="12" y1="8" x2="12.01" y2="8"/>
      </svg>
    </div>
    <button type="button"
         class="w-10 h-10 rounded-[9px] flex items-center justify-center cursor-pointer bg-transparent border-none
                transition-colors duration-150 hover:bg-lilate/[0.12]"
         [matTooltip]="'exam-device-settings.title' | translate"
         matTooltipPosition="left"
         (click)="openDeviceSettings.emit()">
      <mat-icon class="icon-size-5 text-lilate-dark" svgIcon="heroicons_outline:cog-6-tooth"></mat-icon>
    </button>
    @if (showAbandon()) {
    <button type="button"
         class="w-10 h-10 rounded-[9px] flex items-center justify-center cursor-pointer bg-transparent border-none
                transition-colors duration-150 hover:bg-red-500/[0.12]
                disabled:opacity-40 disabled:cursor-not-allowed"
         [matTooltip]="'ai-exam-slide.abandon-test' | translate"
         matTooltipPosition="left"
         [disabled]="abandonDisabled()"
         (click)="abandonTest.emit()">
      <svg class="w-[18px] h-[18px] text-red-500" viewBox="0 0 24 24" fill="none" stroke="currentColor"
           stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
        <path d="M18 6 6 18M6 6l12 12"/>
      </svg>
    </button>
    }
  </div>

</div>
